module.exports = __webpack_public_path__ + "static/media/Pin-Light-Viatura.945a9009.svg";